import { render, staticRenderFns } from "./InvPF_Items.vue?vue&type=template&id=f4924958"
import script from "./InvPF_Items.vue?vue&type=script&lang=js"
export * from "./InvPF_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports